
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API_URL } from "../../config";


const initialState = {
    isLoading: false,
    produitList: [],
    produitDetails: null,
};

export const addProduit = createAsyncThunk(
    'produit/addProduit',
    async (produitData) => {
        console.log("addProduit", produitData);
        const response = await axios.post(
            API_URL + `/api/admin/produit/addProduit`,
            produitData,
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json/multipart/form-data",
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                },
            }
        );
        return response.data;
    }
);

export const editProduit = createAsyncThunk(
    'produit/editProduit',
    async ({ id, produitData }) => {
        const response = await axios.put(
            API_URL + `/api/admin/produit/editProduit/${id}`,
            produitData,
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json/multipart/form-data",
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                },
            }
        );
        return response.data;
    }
);

export const getProduct = createAsyncThunk(
    'produit/getProduct',
    async (productId) => {
        console.log("getProduct", "request");
        const response = await axios.get(
            API_URL +`/api/admin/produit/getProduct/${productId}`,
        );
        return response.data;
    }
);

export const getAllProduits = createAsyncThunk(
    'produit/getAllProduits',
    async () => {
        const result = await axios.get(
            API_URL +`/api/admin/produit/getAllProduits`,
        );

        return result?.data
    }
);

export const deleteProduit = createAsyncThunk(
    'produit/deleteProduit',
    async (productId) => {
        console.log("deleteProduit", "request");
        const response = await axios.delete(
            API_URL +`/api/admin/produit/deleteProduit/${productId}`,
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "application/json/multipart/form-data",
                    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate",
                },
            }
        );
        return response.data;
    }
)

export const produitSlice = createSlice({
    name: "produit",
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(getAllProduits.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getAllProduits.fulfilled, (state, action) => {
                state.isLoading = false;
                state.produitList = action.payload.data;
            })
            .addCase(getAllProduits.rejected, (state) => {
                state.isLoading = false;
                state.produitList = [];
                console.log("getAllProduits", "error");
            })
            .addCase(getProduct.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getProduct.fulfilled, (state, action) => {
                state.isLoading = false;
                state.produitDetails = action.payload.data;
            })
            .addCase(getProduct.rejected, (state) => {
                state.isLoading = false;
                state.produitDetails = null;
            })
    },
});


export default produitSlice.reducer
